import type {ReactElement} from 'react';
import React from 'react';
import {useGetSlideShowItemWithSelectedVideoSlide} from '@Hooks/poster-editor/useGetSlideShowItemWithSelectedVideoSlide';
import {BaseVideoMediaControls} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-video-media-controls';
import type {ItemData} from '@PosterWhiteboard/page/add-item.class';
import {useGetKeyFromSelectedVideoSlide} from '@Hooks/poster-editor/useGetKeyFromSelectedVideoSlide';
import {RemoveBackgroundStatus} from '@PosterWhiteboard/items/item/item.types';

export function VideoSlideMediaControls(): ReactElement<any> {
  const {activeSlide, activeItem} = useGetSlideShowItemWithSelectedVideoSlide();
  const removeBackground = useGetKeyFromSelectedVideoSlide('removeBackground');
  const removeBackgroundStatus = removeBackground?.isBackgroundBeingRemoved ? RemoveBackgroundStatus.REMOVING : removeBackground?.isBackgroundRemoved ? RemoveBackgroundStatus.REMOVED : RemoveBackgroundStatus.NONE;

  const onReplaceVideo = (itemToReplaceWith: ItemData): void => {
    const currentPage = window.posterEditor?.whiteboard?.getCurrentPage();
    if (!currentPage) {
      return;
    }

    void currentPage.items.replaceItems.replaceMediaSlide(itemToReplaceWith, activeSlide, activeItem);
  };

  const onUnMute = (): void => {
    void activeItem.updateSlideFromObject(activeSlide.uid, {
      volume: activeSlide.isMuted() ? 1 : 0,
    });
  };

  return (
    <BaseVideoMediaControls
      activeItem={activeSlide}
      removeBackgroundStatus={removeBackgroundStatus}
      onReplaceVideo={onReplaceVideo}
      onUnMute={onUnMute}
    />
  );
}
